import React from 'react';

import cl from './Partners.module.css'

import bitFenix from '../../assets/images/bitfenix.svg'
import visa from '../../assets/images/visa.svg'
import coinbase from '../../assets/images/coinbase.svg'
import mastercard from '../../assets/images/mastercard.svg'
import tether from '../../assets/images/tether.svg'
import whitebit from '../../assets/images/whitebit.svg'






const Partners = () => {
    return (
        <div className={cl.partners_page}>
            <div className={cl.left_side_partner}>
                <h2 className={cl.title_partner}>
                    Partners
                </h2>
                <p className={cl.description_partner}>
                    Our trusted
                    partners
                </p>
            </div>
            <div className={cl.right_side_partner}>
                <div className={cl.card_item}>
                    <img src={bitFenix} alt="#pltHealthImg" />
                </div>
                <div className={cl.card_item}>
                    <img src={visa} alt="#surgent" />
                </div>
                
                <div className={cl.card_item}>
                    <img src={coinbase} alt="#plGoDoc" />
                </div>
                <div className={cl.card_item}>
                    <img src={mastercard} alt="#plSurgent" />
                </div>
                <div className={cl.card_item}>
                    <img src={tether} alt="#plHome" />
                </div>
                <div className={cl.card_item}>
                    <img src={whitebit} alt="#plHome" />
                </div>
            </div>
        </div>
    );
};

export default Partners;